import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "page-filters pf-bar" }
const _hoisted_3 = { class: "pf-search" }
const _hoisted_4 = { class: "full-table" }
const _hoisted_5 = ["href"]
const _hoisted_6 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  style: {"text-align":"center"}
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 2,
  style: {"text-align":"center"}
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 3,
  style: {"text-align":"center"}
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = {
  key: 4,
  style: {"text-align":"center"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 5,
  style: {"text-align":"center"}
}
const _hoisted_17 = ["onClick"]
const _hoisted_18 = {
  key: 0,
  class: "error-msg-wrap"
}
const _hoisted_19 = { class: "form-wrapper slide-up" }
const _hoisted_20 = { class: "form-close" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_phone_input = _resolveComponent("phone-input")!
  const _component_form_view_submissions = _resolveComponent("form-view-submissions")!
  const _component_add_edit_form = _resolveComponent("add-edit-form")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "page-bar" }, [
      _createElementVNode("div", null, [
        _createElementVNode("div", { class: "page-bar-sub" }, "Work"),
        _createElementVNode("div", { class: "page-bar-main" }, "Forms")
      ])
    ], -1)),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[14] || (_cache[14] = _createElementVNode("svg", {
            viewBox: "0 0 24 24",
            "aria-hidden": "true"
          }, [
            _createElementVNode("circle", {
              cx: "11",
              cy: "11",
              r: "7"
            }),
            _createElementVNode("path", { d: "M21 21l-4.35-4.35" })
          ], -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQ) = $event)),
            placeholder: "Search",
            "aria-label": "Search",
            onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.search()))
          }, null, 544), [
            [_vModelText, _ctx.searchQ]
          ])
        ]),
        (_ctx.$store.state.user.teamHubRole == 'Admin')
          ? _withDirectives((_openBlock(), _createElementBlock("select", {
              key: 0,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formStatus) = $event)),
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getForms()))
            }, [...(_cache[15] || (_cache[15] = [
              _createElementVNode("option", { value: "published" }, "Published", -1),
              _createElementVNode("option", { value: "unpublished" }, "Unpublished", -1)
            ]))], 544)), [
              [_vModelSelect, _ctx.formStatus]
            ])
          : _createCommentVNode("", true),
        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "pf-spacer" }, null, -1)),
        (_ctx.$store.state.user.teamHubRole == 'Admin')
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addNewForm())),
              class: "add-btn"
            }, "Add"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("table", _hoisted_4, [
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.forms, (form, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, [
                _createElementVNode("a", {
                  href: '/team-hub?formID=' + form.ID,
                  target: "_blank"
                }, _toDisplayString(form.Name), 9, _hoisted_5)
              ]),
              (_ctx.$store.state.user.teamHubRole == 'Admin' || (_ctx.$store.state.user.companyID == 1 && _ctx.$store.state.user.isAdmin))
                ? (_openBlock(), _createElementBlock("td", _hoisted_6, [
                    (_ctx.$store.state.user.teamHubRole == 'Admin' || form.ID == 8)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          onClick: _withModifiers(($event: any) => (_ctx.viewSubmissions(form)), ["prevent"])
                        }, "Submissions", 8, _hoisted_7))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$store.state.user.isAdmin)
                ? (_openBlock(), _createElementBlock("td", _hoisted_8, [
                    _createElementVNode("a", {
                      onClick: _withModifiers(($event: any) => (_ctx.sendText(form)), ["prevent"])
                    }, "Send Text", 8, _hoisted_9)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$store.state.user.teamHubRole == 'Admin')
                ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                    _createElementVNode("a", {
                      onClick: _withModifiers(($event: any) => (_ctx.editForm(form)), ["prevent"])
                    }, "Edit", 8, _hoisted_11)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$store.state.user.teamHubRole == 'Admin' && form.Published)
                ? (_openBlock(), _createElementBlock("td", _hoisted_12, [
                    _createElementVNode("a", {
                      onClick: ($event: any) => (_ctx.unpublish(form))
                    }, "Unpublish", 8, _hoisted_13)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$store.state.user.teamHubRole == 'Admin' && !form.Published)
                ? (_openBlock(), _createElementBlock("td", _hoisted_14, [
                    _createElementVNode("a", {
                      onClick: ($event: any) => (_ctx.publish(form))
                    }, "Publish", 8, _hoisted_15)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$store.state.user.teamHubRole == 'Admin' && !form.Published)
                ? (_openBlock(), _createElementBlock("td", _hoisted_16, [
                    _createElementVNode("a", {
                      onClick: ($event: any) => (_ctx.deleteForm(form))
                    }, "Delete", 8, _hoisted_17)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ])
    ], 2),
    (_ctx.showSendText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                type: "button",
                class: "form-close-x",
                title: "Close",
                onClick: _cache[5] || (_cache[5] = () => { _ctx.showSendText = false })
              }, "×")
            ]),
            _createElementVNode("div", null, [
              _cache[17] || (_cache[17] = _createElementVNode("h3", null, "Phone Number", -1)),
              _createVNode(_component_phone_input, {
                modelValue: _ctx.sendTextFormData.phone,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.sendTextFormData.phone) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", null, [
              _cache[18] || (_cache[18] = _createElementVNode("h3", null, "Message (link will be included)", -1)),
              _withDirectives(_createElementVNode("textarea", {
                style: {"height":"170px"},
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.sendTextFormData.text) = $event))
              }, null, 512), [
                [_vModelText, _ctx.sendTextFormData.text]
              ])
            ]),
            _createElementVNode("input", {
              class: _normalizeClass(_ctx.disableButton ? 'disable-button' : ''),
              type: "submit",
              value: "Submit",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.submitSendText()))
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showSubmissions)
      ? (_openBlock(), _createBlock(_component_form_view_submissions, {
          key: 1,
          formToView: _ctx.formToViewSubmissions,
          onClose: _cache[9] || (_cache[9] = () => {_ctx.showSubmissions = false})
        }, null, 8, ["formToView"]))
      : _createCommentVNode("", true),
    (_ctx.showAddForm)
      ? (_openBlock(), _createBlock(_component_add_edit_form, {
          key: 2,
          formToEdit: _ctx.formToEdit,
          onClose: _cache[10] || (_cache[10] = ($event: any) => (_ctx.closeAddEdit()))
        }, null, 8, ["formToEdit"]))
      : _createCommentVNode("", true),
    (_ctx.showConfirmUnpublish)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 3,
          onConfirm: _ctx.unpublishConfirm,
          onCancel: _cache[11] || (_cache[11] = () => { _ctx.showConfirmUnpublish = false; }),
          msg: "Are you sure you would like to unpublish this form?"
        }, null, 8, ["onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.showConfirmPublish)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 4,
          onConfirm: _ctx.publishConfirm,
          onCancel: _cache[12] || (_cache[12] = () => { _ctx.showConfirmPublish = false; }),
          msg: "Are you sure you would like to publish this form?"
        }, null, 8, ["onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.showConfirmDelete)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 5,
          onConfirm: _ctx.deleteConfirm,
          onCancel: _cache[13] || (_cache[13] = () => { _ctx.showConfirmDelete = false; }),
          msg: "Are you sure you would like to PERMANENTLY DELETE this form?"
        }, null, 8, ["onConfirm"]))
      : _createCommentVNode("", true)
  ]))
}